import { buildModelManager } from "../builder.js";
const DefaultDiscountLinksSelection = {
  __typename: true,
  id: true,
  code: true,
  conversionRate: true,
  createdAt: true,
  maxUses: true,
  message: true,
  orderCount: true,
  shopId: true,
  status: true,
  type: true,
  unallowedUses: true,
  updatedAt: true,
  value: true,
  visitorCount: true
};
const modelApiIdentifier = "discountLinks";
const pluralModelApiIdentifier = "discountLinkss";
;
;
;
;
;
;
;
;
;
;
const DiscountLinksManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultDiscountLinksSelection,
  [
    {
      type: "findOne",
      operationName: modelApiIdentifier,
      modelApiIdentifier,
      findByVariableName: "id",
      defaultSelection: DefaultDiscountLinksSelection,
      namespace: null
    },
    {
      type: "maybeFindOne",
      operationName: modelApiIdentifier,
      modelApiIdentifier,
      findByVariableName: "id",
      defaultSelection: DefaultDiscountLinksSelection,
      namespace: null
    },
    {
      type: "findMany",
      operationName: pluralModelApiIdentifier,
      modelApiIdentifier,
      defaultSelection: DefaultDiscountLinksSelection,
      namespace: null
    },
    {
      type: "findFirst",
      operationName: pluralModelApiIdentifier,
      modelApiIdentifier,
      defaultSelection: DefaultDiscountLinksSelection,
      namespace: null
    },
    {
      type: "maybeFindFirst",
      operationName: pluralModelApiIdentifier,
      modelApiIdentifier,
      defaultSelection: DefaultDiscountLinksSelection,
      namespace: null
    },
    {
      type: "findOne",
      operationName: pluralModelApiIdentifier,
      functionName: "findById",
      findByField: "id",
      findByVariableName: "id",
      modelApiIdentifier,
      defaultSelection: DefaultDiscountLinksSelection,
      namespace: null
    },
    {
      type: "maybeFindOne",
      operationName: pluralModelApiIdentifier,
      functionName: "maybeFindById",
      findByField: "id",
      findByVariableName: "id",
      modelApiIdentifier,
      defaultSelection: DefaultDiscountLinksSelection,
      namespace: null
    },
    {
      type: "findOne",
      operationName: pluralModelApiIdentifier,
      functionName: "findByCode",
      findByField: "code",
      findByVariableName: "code",
      modelApiIdentifier,
      defaultSelection: DefaultDiscountLinksSelection,
      namespace: null
    },
    {
      type: "maybeFindOne",
      operationName: pluralModelApiIdentifier,
      functionName: "maybeFindByCode",
      findByField: "code",
      findByVariableName: "code",
      modelApiIdentifier,
      defaultSelection: DefaultDiscountLinksSelection,
      namespace: null
    },
    {
      type: "action",
      operationName: "createDiscountLinks",
      operationReturnType: "CreateDiscountLinks",
      functionName: "create",
      namespace: null,
      modelApiIdentifier,
      operatesWithRecordIdentity: false,
      modelSelectionField: modelApiIdentifier,
      isBulk: false,
      isDeleter: false,
      variables: {
        discountLinks: { required: false, type: "CreateDiscountLinksInput" }
      },
      hasAmbiguousIdentifier: false,
      paramOnlyVariables: [],
      hasReturnType: false,
      acceptsModelInput: true,
      hasCreateOrUpdateEffect: true,
      defaultSelection: DefaultDiscountLinksSelection
    },
    {
      type: "action",
      operationName: "bulkCreateDiscountLinks",
      functionName: "bulkCreate",
      isBulk: true,
      isDeleter: false,
      hasReturnType: false,
      acceptsModelInput: true,
      operatesWithRecordIdentity: false,
      singleActionFunctionName: "create",
      modelApiIdentifier,
      modelSelectionField: pluralModelApiIdentifier,
      namespace: null,
      variables: {
        inputs: { required: true, type: "[BulkCreateDiscountLinksInput!]" }
      },
      paramOnlyVariables: [],
      defaultSelection: DefaultDiscountLinksSelection
    },
    {
      type: "action",
      operationName: "updateDiscountLinks",
      operationReturnType: "UpdateDiscountLinks",
      functionName: "update",
      namespace: null,
      modelApiIdentifier,
      operatesWithRecordIdentity: true,
      modelSelectionField: modelApiIdentifier,
      isBulk: false,
      isDeleter: false,
      variables: {
        id: { required: true, type: "GadgetID" },
        discountLinks: { required: false, type: "UpdateDiscountLinksInput" }
      },
      hasAmbiguousIdentifier: false,
      paramOnlyVariables: [],
      hasReturnType: false,
      acceptsModelInput: true,
      hasCreateOrUpdateEffect: true,
      defaultSelection: DefaultDiscountLinksSelection
    },
    {
      type: "action",
      operationName: "bulkUpdateDiscountLinks",
      functionName: "bulkUpdate",
      isBulk: true,
      isDeleter: false,
      hasReturnType: false,
      acceptsModelInput: true,
      operatesWithRecordIdentity: true,
      singleActionFunctionName: "update",
      modelApiIdentifier,
      modelSelectionField: pluralModelApiIdentifier,
      namespace: null,
      variables: {
        inputs: { required: true, type: "[BulkUpdateDiscountLinksInput!]" }
      },
      paramOnlyVariables: [],
      defaultSelection: DefaultDiscountLinksSelection
    },
    {
      type: "action",
      operationName: "deleteDiscountLinks",
      operationReturnType: "DeleteDiscountLinks",
      functionName: "delete",
      namespace: null,
      modelApiIdentifier,
      operatesWithRecordIdentity: true,
      modelSelectionField: modelApiIdentifier,
      isBulk: false,
      isDeleter: true,
      variables: { id: { required: true, type: "GadgetID" } },
      hasAmbiguousIdentifier: false,
      paramOnlyVariables: [],
      hasReturnType: false,
      acceptsModelInput: false,
      hasCreateOrUpdateEffect: false,
      defaultSelection: null
    },
    {
      type: "action",
      operationName: "bulkDeleteDiscountLinks",
      functionName: "bulkDelete",
      isBulk: true,
      isDeleter: true,
      hasReturnType: false,
      acceptsModelInput: false,
      operatesWithRecordIdentity: true,
      singleActionFunctionName: "delete",
      modelApiIdentifier,
      modelSelectionField: pluralModelApiIdentifier,
      namespace: null,
      variables: { ids: { required: true, type: "[GadgetID!]" } },
      paramOnlyVariables: [],
      defaultSelection: null
    },
    {
      type: "action",
      operationName: "discountFunctionsDiscountLinks",
      operationReturnType: "DiscountFunctionsDiscountLinks",
      functionName: "discountFunctions",
      namespace: null,
      modelApiIdentifier,
      operatesWithRecordIdentity: true,
      modelSelectionField: modelApiIdentifier,
      isBulk: false,
      isDeleter: false,
      variables: { id: { required: true, type: "GadgetID" } },
      hasAmbiguousIdentifier: false,
      paramOnlyVariables: [],
      hasReturnType: false,
      acceptsModelInput: false,
      hasCreateOrUpdateEffect: false,
      defaultSelection: DefaultDiscountLinksSelection
    },
    {
      type: "action",
      operationName: "bulkDiscountFunctionsDiscountLinks",
      functionName: "bulkDiscountFunctions",
      isBulk: true,
      isDeleter: false,
      hasReturnType: false,
      acceptsModelInput: false,
      operatesWithRecordIdentity: true,
      singleActionFunctionName: "discountFunctions",
      modelApiIdentifier,
      modelSelectionField: pluralModelApiIdentifier,
      namespace: null,
      variables: { ids: { required: true, type: "[GadgetID!]" } },
      paramOnlyVariables: [],
      defaultSelection: DefaultDiscountLinksSelection
    },
    {
      type: "action",
      operationName: "upsertDiscountLinks",
      operationReturnType: "UpsertDiscountLinks",
      functionName: "upsert",
      namespace: null,
      modelApiIdentifier,
      operatesWithRecordIdentity: false,
      modelSelectionField: modelApiIdentifier,
      isBulk: false,
      isDeleter: false,
      variables: {
        on: { required: false, type: "[String!]" },
        discountLinks: { required: false, type: "UpsertDiscountLinksInput" }
      },
      hasAmbiguousIdentifier: false,
      paramOnlyVariables: ["on"],
      hasReturnType: {
        "... on CreateDiscountLinksResult": { hasReturnType: false },
        "... on UpdateDiscountLinksResult": { hasReturnType: false }
      },
      acceptsModelInput: true,
      hasCreateOrUpdateEffect: true,
      defaultSelection: DefaultDiscountLinksSelection
    },
    {
      type: "action",
      operationName: "bulkUpsertDiscountLinks",
      functionName: "bulkUpsert",
      isBulk: true,
      isDeleter: false,
      hasReturnType: false,
      acceptsModelInput: true,
      operatesWithRecordIdentity: false,
      singleActionFunctionName: "upsert",
      modelApiIdentifier,
      modelSelectionField: pluralModelApiIdentifier,
      namespace: null,
      variables: {
        inputs: { required: true, type: "[BulkUpsertDiscountLinksInput!]" }
      },
      paramOnlyVariables: ["on"],
      defaultSelection: DefaultDiscountLinksSelection
    }
  ]
);
export {
  DefaultDiscountLinksSelection,
  DiscountLinksManager
};
//# sourceMappingURL=DiscountLinks.js.map
